import React from 'react';
import { Redirect } from 'react-router-dom';
import Yorum from 'src/views/Chat';
import Error404 from 'src/views/Error404';
import OverView from 'src/views/Overview';
import Profil from 'src/views/Profile';
import Isler from 'src/views/WorkOrder';
import DashboardLayout from './layouts/Dashboard';
import ErrorLayout from './layouts/Error';
import AeeeUrunEsleView from './views/AeeeMatching';
import BultenlerView from './views/Bulletin';
import MaterialFindView from './views/MaterialFind';
import ExtraWarrantySalesListView from './views/ExtraWarrantySalesList';
import DefectSoundRecognitionView from './views/DefectSoundRecognition';
import DealerVisitView from './views/DealerVisit';
import CreditView from './views/Credit';
import VideoHelperView from './views/VideoHelper';
import CentralPaperControlView from './views/CentralPaperControl';
import DashboardDefaultView from './views/DashboardDefault';
import DosyaView from './views/File';
import FormView from './views/Form';
import YardimView from './views/Help';
import MaterialImageMapView from './views/MaterialImageMap';
import MalzemeIhtiyacView from './views/MaterialRequirement';
import YaziciView from './views/Printer';
import UrunKabulView from './views/ProductAcceptance';
import InventoryView from './views/Inventory';
import ProductChangeScrapView from './views/ProductChangeScrap';
import ProdcutDetailControlView from './views/ProductDetailControl';
import MaterialRequestView from './views/MaterialRequest';
import RemoteHelpView from './views/RemoteHelp';
import SatisView from './views/Sales';
import ServisIletisimView from './views/ServiceContact';
import DepoTakipView from './views/WarehouseTracking';
import UyariMerkeziView from './views/WarningCenter';
import QrBarcodeMapView from './views/QrBarcodeMap';
import PerformanceView from './views/Performance';
import SchedulingView from './views/Scheduling';
import MoneyView from './views/Money';
import TimeView from './views/Time';
import NPSView from './views/NPS';
import ScrapView from './views/Scrap';

import WareHouseControlView from './views/WareHouseControl';
import SLAView from './views/SLA';
import OpenWorkView from './views/OpenWork';
import OneTimeServiceView from './views/OneTimeService';
import ComplaintReportView from './views/ComplaintReport';
import CentralPaperControlServiceShopView from './views/CentralPaperControlServiceShop';
import Solution3DaysView from './views/Solution3Days';
import CariHesapView from './views/CariHesap';
import Unauthorized from './layouts/Auth/Unauthorized';
import BodForm from './views/Form/BodForm';
import TeknisyenKocuChatView from './views/TechnicianCoach/TechnicianCoachChat';

export default [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/" />
  },
  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      {
        path: '/errors/error-404',
        exact: true,
        component: Error404
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    path: '/Unauthorized',
    component: ErrorLayout,
    routes: [
      {
        path: '/Unauthorized',
        exact: true,
        component: Unauthorized
      },
      {
        component: () => <Redirect to="./layouts/Auth/Unauthorized" />
      }
    ]
  },
  {
    route: '*',
    component: DashboardLayout,
    routes: [
      {
        path: '/chat',
        exact: true,
        component: Yorum
      },
      {
        path: '/chat/:id',
        exact: true,
        component: Yorum
      },
      {
        path: '/dashboards/default',
        exact: true,
        component: DashboardDefaultView
      },
      {
        path: '/WorkOrder/:id/:tab',
        exact: true,
        component: Isler
      },
      {
        path: '/overview',
        exact: true,
        component: OverView
      },
      {
        path: '/Satis',
        exact: true,
        component: SatisView
      },
      {
        path: '/Performance/:id',
        exact: true,
        component: PerformanceView
      },
      {
        path: '/Performance/:id/:tab',
        exact: true,
        component: PerformanceView
      },
      {
        path: '/UrunKabul',
        exact: true,
        component: UrunKabulView
      },
      {
        path: '/Inventory',
        exact: true,
        component: InventoryView
      },
      {
        path: '/DepoTakip',
        exact: true,
        component: DepoTakipView
      },
      {
        path: '/AeeeUrunEsle',
        exact: true,
        component: AeeeUrunEsleView
      },
      {
        path: '/Bultenler',
        exact: true,
        component: BultenlerView
      },
      {
        path: '/MaterialFind',
        exact: true,
        component: MaterialFindView
      },
      {
        path: '/ExtraWarrantySalesList',
        exact: true,
        component: ExtraWarrantySalesListView
      },
      {
        path: '/DefectSoundRecognition',
        exact: true,
        component: DefectSoundRecognitionView
      },
      {
        path: '/DealerVisit',
        exact: true,
        component: DealerVisitView
      },

      {
        path: '/Credit',
        exact: true,
        component: CreditView
      },
      {
        path: '/VideoHelper',
        exact: true,
        component: VideoHelperView
      },
      {
        path: '/Dosya',
        exact: true,
        component: DosyaView
      },
      {
        path: '/ProductDetailControl',
        exact: true,
        component: ProdcutDetailControlView
      },
      {
        path: '/MaterialRequest',
        exact: true,
        component: MaterialRequestView
      },
      {
        path: '/QrBarcodeMap',
        exact: true,
        component: QrBarcodeMapView
      },
      {
        path: '/Scrap',
        exact: true,
        component: ScrapView
      },
      {
        path: '/RemoteHelp',
        exact: true,
        component: RemoteHelpView
      },
      {
        path: '/MalzemeIhtiyac',
        exact: true,
        component: MalzemeIhtiyacView
      },
      {
        path: '/MaterialImageMap',
        exact: true,
        component: MaterialImageMapView
      },
      {
        path: '/UyariMerkezi',
        exact: true,
        component: UyariMerkeziView
      },
      {
        path: '/Yazici',
        exact: true,
        component: YaziciView
      },
      {
        path: '/ServisIletisim',
        exact: true,
        component: ServisIletisimView
      },
      {
        path: '/TechnicianCoachChat',
        exact: true,
        component: TeknisyenKocuChatView
      },
      {
        path: '/Form/:id/:FisNo',
        exact: true,
        component: FormView
      },
      {
        path: '/BodForm/:fisNo',
        exact: true,
        component: BodForm
      },
      {
        path: '/CentralPaperControl/:searchType?/:searchText?',
        exact: true,
        component: CentralPaperControlView
      },
      {
        path: '/ProductChangeScrap',
        exact: true,
        component: ProductChangeScrapView
      },
      {
        path: '/Yardim',
        exact: true,
        component: YardimView
      },
      {
        path: '/profile/:id',
        exact: true,
        component: Profil
      },
      {
        path: '/profile/:id/:tab',
        exact: true,
        component: Profil
      },
      {
        path: '/Solution3Days',
        exact: true,
        component: Solution3DaysView

      },
      {
        path: '/Scheduling',
        exact: true,
        component: SchedulingView

      },
      {
        path: '/Solution3Days',
        exact: true,
        component: Solution3DaysView

      },
      {
        path: '/Money',
        exact: true,
        component: MoneyView
      },
      {
        path: '/Time',
        exact: true,
        component: TimeView
      },
      {
        path: '/NPS',
        exact: true,
        component: NPSView
      },

      {
        path: '/WareHouseControl',
        exact: true,
        component: WareHouseControlView
      },
      {
        path: '/SLA',
        exact: true,
        component: SLAView
      },
      {
        path: '/OpenWork',
        exact: true,
        component: OpenWorkView
      },
      {
        path: '/OneTimeService',
        exact: true,
        component: OneTimeServiceView
      },
      {
        path: '/ComplaintReport',
        exact: true,
        component: ComplaintReportView
      },
      {
        path: '/CentralPaperControlServiceShop',
        exact: true,
        component: CentralPaperControlServiceShopView
      },
      {
        path: '/CariHesap',
        exact: true,
        component: CariHesapView
      },





      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  }
];
